import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { LocalizedDatePipe } from '../ubi-core/pipes/LocalizedDatePipe';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

declare var require: any;

@Injectable()
export class MetadataService {

    private appVersion: string = require( '../../../package.json').version;

    entity: string;

    constructor(private http: Http) {
    }

    public setEntity(entity: string) {
        this.entity = entity;
    }

    public getMetadataGrid() {
        return this.http
            .get('./assets/metadata/' + this.entity + '/' + this.entity + '.grid.json?v=' + this.appVersion)
            .map(response => {
                const responseAsJson = response.json();
                const hasPipe = responseAsJson.filter(item => item.hasOwnProperty('pipe'));

                hasPipe.forEach(element => {

                    switch (element.pipe) {
                        case 'DateTimePipe':
                            element.pipe = new LocalizedDatePipe('pt-PT', 'yyyy/MM/dd hh:mm');
                            break;
                        case 'DatePipe':
                            element.pipe = new LocalizedDatePipe('pt-PT', 'yyyy/MM/dd');
                            break;
                        default:
                            break;
                    }

                });

                return responseAsJson;
            })
            .catch(this.handleError);
    }

    public getMetadataDetail() {
        return this.http
            .get('./assets/metadata/' + this.entity + '/' + this.entity + '.detail.json?v=' + this.appVersion)
            .map(response => response.json())
            .catch(this.handleError);
    }

    public getFilters() {
        return this.http
            .get('./assets/metadata/' + this.entity + '/' + this.entity + '.filters.json?v=' + this.appVersion)
            .map(response => response.json())
            .catch(this.handleError);
    }

    public getFiltersQB() {
        return this.http
            .get('./assets/metadata/' + this.entity + '/' + this.entity + '.filtersQB.json?v=' + this.appVersion)
            .map(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        console.error('MetadataService::handleError', error, this.entity);
        return Observable.throw(error);
    }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/ubi-core/metadata.service.ts